<div class="flex min-h-0 w-full flex-col md:mx-auto md:max-w-[62rem] md:p-4">
    <div class="hidden md:block">
        <rwidget-alert></rwidget-alert>
    </div>

    <div class="flex-column flex-justify-center flex md:flex-row">
        <header class="md:ml-4 md:mr-8 md:w-60">
            <div class="mb-3 flex justify-center md:justify-start">
                <ng-content select="[header]"></ng-content>
            </div>
            <rwidget-alert class="md:hidden"></rwidget-alert>
            <div class="hidden md:block">
                <ng-content select="[desktop-header-sub-content]"></ng-content>
            </div>
        </header>

        <main
            class="bg-transparent md:rounded-lg md:bg-[#F0F0F0] md:p-4 dark:md:bg-contrast-black"
            [ngClass]="{
                'md:w-[44rem]': !secondMainAreaEnabled,
                'md:w-[26rem]': secondMainAreaEnabled
            }">
            <ng-content select="[main-1]"></ng-content>
            <div class="md:hidden" *ngIf="secondMainAreaEnabled">
                <ng-content select="[main-2-mobile]"></ng-content>
            </div>
        </main>

        <main class="ml-4 hidden w-64 md:block" *ngIf="secondMainAreaEnabled">
            <ng-content select="[main-2-desktop]"></ng-content>
        </main>

        <div class="mx-4 mt-2 md:m-0 md:hidden">
            <ng-content select="[mobile-bottom]"></ng-content>
        </div>
    </div>
</div>
